import { render, staticRenderFns } from "./goldenSentence.vue?vue&type=template&id=542a0b86&scoped=true&"
import script from "./goldenSentence.vue?vue&type=script&lang=js&"
export * from "./goldenSentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a0b86",
  null
  
)

export default component.exports